import styled from 'styled-components';

export const Container = styled.div`
  padding: 80px 24px 24px 154px;
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Стили для модального окна добавления агентов
export const SecondModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

export const SecondModalContent = styled.div`
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  border-radius: 8px;
  padding: 0;
  max-width: 700px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.switcher ? '#525252' : '#f3f4f6'};
  }
`;

export const SearchSection = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
`;

export const SearchTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 16px 0;
`;

export const SearchForm = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#d1d5db'};
  border-radius: 6px;
  background: ${props => props.switcher ? '#2d2d2d' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-size: 14px;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  }
`;

export const SearchButton = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #5a67d8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

export const AgentsListSection = styled.div`
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
`;

export const AgentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: ${props => props.switcher ? '#2d2d2d' : '#f9fafb'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.switcher ? '#404040' : '#ffffff'};
    border-color: ${props => props.switcher ? '#6b7280' : '#d1d5db'};
  }
`;

export const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AgentName = styled.span`
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  font-weight: 600;
  font-size: 14px;
`;

export const AgentLcid = styled.span`
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  font-size: 12px;
`;

export const AddAgentButton = styled.button`
  padding: 6px 12px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #059669;
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

export const LoadingText = styled.div`
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  font-size: 14px;
`;